import { IconButton } from "@evergis/ui";
import React, { FC } from "react";
import { useAddHandlers } from "./hooks/useAddHandlers";
import { ProjectInfoBlock } from "./types";

export interface AddInfoBlockProps {
  add: (block: ProjectInfoBlock) => void;
  index: number;
  items: ProjectInfoBlock[];
  setItems: (items: ProjectInfoBlock[]) => void;
}

export const AddInfoBlock: FC<AddInfoBlockProps> = ({ add, items, index, setItems }) => {
  const { options, onSelect } = useAddHandlers(add, setItems, items);

  return (
    <>
      {options.map(option => (
        <IconButton key={option.icon} kind={option.icon} onClick={() => onSelect([option], index)} />
      ))}
    </>
  );
};
